import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';

type OrderedIdentifier = ProjectByIdQuery['projectById']['state']['orderedIdentifiers'][number];

export function syncOrderedIdentifiers(viewer: RendererContextType['viewer'], orderedIdentifiers: OrderedIdentifier[] | undefined): void {
  if (!orderedIdentifiers || !viewer) return;
  viewer.scene.orderedIdentifiers = orderedIdentifiers;
}
